import apiCall from '@/api/eos-detective'
const EosApi = require('eosjs-api')

let options = {
  httpEndpoint: 'https://eos.greymass.com'
}

const eos = EosApi(options)

const state = {
  accountProfileResults: {
    account: '-',
    contract: '-',
    token: '-',
    total_tokens_received: 0,
    score: 0,
    categories: {}
  },
  accountChainInfo: {
    core_liquid_balance: 0,
    self_delegated_bandwidth: {
      cpu_weight: 0,
      net_weight: 0
    }
  }
}

const getters = {
}
const actions = {
  loadAccountProfile ({ commit, rootState }) {
    commit('setLoading', true, { root: true })
    apiCall({
      apiToken: rootState.auth.profile.userApiToken,
      endpoint: 'profile',
      params: { account: rootState.filter.search }
    })
      .then((resp) => {
        commit('setAccountProfile', resp)
        commit('setLoading', false, { root: true })
      })
      .catch(() => {
        commit('setLoading', false, { root: true })
      })
    eos.getAccount(rootState.filter.search).then(resp => {
      commit('setAccountChainInfo', resp)
    })
  }
}
const mutations = {
  setAccountProfile (state, results) {
    state.accountProfileResults = results
  },
  setAccountChainInfo (state, results) {
    state.accountChainInfo = results
  },
  resetAccountProfile (state) {
    state.accountProfileResults = {
      account: '-',
      contract: '-',
      token: '-',
      total_tokens_received: 0,
      score: 0,
      categories: {}
    }
    state.accountChainInfo = {
      core_liquid_balance: 0,
      self_delegated_bandwidth: {
        cpu_weight: 0,
        net_weight: 0
      }
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
